/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const DIRECT_UPLOAD_SMART_CALL_AUDIO_MUTATION = gql`
  mutation tenantDirectUpload( $file: [TenantDirectUploadCreateInput!] ) {
    tenant {
      directUploadSmartCallSetting( create: $file ) {
        metadata {
          url
          headers
          blobId
          signedBlobId
        }
        errors
      }
    }
  }
`;
